export default __webpack_public_path__ + "static/media/film-strip-blue-title-background.e89f5571.png";